<template>
<div class="">

   <div class="" style="" >
        <div class="row yo-bg-color-primary" style="">
            <div class="col s8 yo-bg-color-primary"><el-input class="no-border" :placeholder="'Search author for Name or Institution'" prefix-icon="el-icon-search" v-model="$contatto.autoreCerca" style="none"> <!-- @click="handleIconClick" --></el-input></div>
            <div class="col s4 yo-bg-color-primary white yo-text-n " style="padding:12px 0 12px 12px;" v-if="numitems>0">{{numitems}} authors found<span v-if="numitems>20">, only the first 20 authors are displayed</span> {{$contatto.autoreCerca}}</div>
            <div class="col s4 yo-bg-color-primary white yo-text-n " style="padding:12px 0 12px 12px;" v-if="numitems<1">No authors found</div>
        </div>
    </div>

    
    <div style="padding:4px 0 48px 0;">
		  <el-collapse accordion>
        <elCerca v-for="item in filtrati" :item="item" v-bind:key="item.id"  v-on:absautoreAdded="absautoreAdded"></elCerca> 
		  </el-collapse>
    </div>


</div>
</template>

<script>
import elCerca from './Autore-elenco.vue'
export default {
   components: {
      elCerca
   }
   ,name: 'Cerca'
   ,data () {
      return {
         numitems: 0
      }
   },
  created () {
  }
   ,methods:{
      absautoreAdded(item){
         this.$emit('absautoreAdded', item)
      }
   }
   ,computed: {
      filtrati: function () {
      this.numitems = this.$teras._autore.length

      console.log("TROVATI "+this.numitems+" autore ora filtro per: "+this.$contatto.autoreCerca)
      
      if(this.numitems==0)
         return {}

      if(this.$contatto.autoreCerca=='' ){
         this.numitems = this.$teras._autore.length
         return this.$teras._autore.slice(0, 20)
      }
      console.log("AAAA")
		var words = this.$contatto.autoreCerca.toString().split('+')
		 
      
		var isFilter = []
		
      for (let item of this.$teras._autore){
			var trovati = 0
			for (let word of words){
				if(
            item.nome.toString().toLowerCase().indexOf(word.toLowerCase()) > -1 
            || 
            item.cognome.toString().toLowerCase().indexOf(word.toLowerCase()) > -1 
            || 
            item.affiliazione.toString().toLowerCase().indexOf(word.toLowerCase()) > -1
            ) 
				trovati++
			}

			if(trovati==words.length)
				isFilter.push(item)        

      }
      this.numitems = isFilter.length

      return (isFilter.length>20) ? isFilter.slice(0, 20) : isFilter
      
      }
   }
}

    
</script>

